module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-group">\r\n    <label for="pwd">'+
((__t=(lang.NEW_PWD))==null?'':_.escape(__t))+
'</label>\r\n    <input type="password" id="pwd" class="form-control" placeholder="'+
((__t=(lang.PASSWD))==null?'':_.escape(__t))+
'" required value="'+
((__t=(pwd))==null?'':_.escape(__t))+
'" />\r\n    <div class="strength-meter">\r\n        <div class="strength-meter-fill"></div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/pwdInput/pwdInputView.ejs
// module id = 441
// module chunks = 0